// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';



export class PatchPlayerData implements flatbuffers.IUnpackableObject<PatchPlayerDataT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):PatchPlayerData {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsPatchPlayerData(bb:flatbuffers.ByteBuffer, obj?:PatchPlayerData):PatchPlayerData {
  return (obj || new PatchPlayerData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsPatchPlayerData(bb:flatbuffers.ByteBuffer, obj?:PatchPlayerData):PatchPlayerData {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new PatchPlayerData()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

dname():string|null
dname(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
dname(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

dnamePlaceholder():string|null
dnamePlaceholder(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
dnamePlaceholder(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

money():number {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

color1():bigint {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readInt64(this.bb_pos + offset) : BigInt('-1');
}

color2():bigint {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.readInt64(this.bb_pos + offset) : BigInt('-1');
}

teamId():number {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
}

static startPatchPlayerData(builder:flatbuffers.Builder) {
  builder.startObject(6);
}

static addDname(builder:flatbuffers.Builder, dnameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, dnameOffset, 0);
}

static addDnamePlaceholder(builder:flatbuffers.Builder, dnamePlaceholderOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, dnamePlaceholderOffset, 0);
}

static addMoney(builder:flatbuffers.Builder, money:number) {
  builder.addFieldInt32(2, money, -1);
}

static addColor1(builder:flatbuffers.Builder, color1:bigint) {
  builder.addFieldInt64(3, color1, BigInt('-1'));
}

static addColor2(builder:flatbuffers.Builder, color2:bigint) {
  builder.addFieldInt64(4, color2, BigInt('-1'));
}

static addTeamId(builder:flatbuffers.Builder, teamId:number) {
  builder.addFieldInt32(5, teamId, -1);
}

static endPatchPlayerData(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createPatchPlayerData(builder:flatbuffers.Builder, dnameOffset:flatbuffers.Offset, dnamePlaceholderOffset:flatbuffers.Offset, money:number, color1:bigint, color2:bigint, teamId:number):flatbuffers.Offset {
  PatchPlayerData.startPatchPlayerData(builder);
  PatchPlayerData.addDname(builder, dnameOffset);
  PatchPlayerData.addDnamePlaceholder(builder, dnamePlaceholderOffset);
  PatchPlayerData.addMoney(builder, money);
  PatchPlayerData.addColor1(builder, color1);
  PatchPlayerData.addColor2(builder, color2);
  PatchPlayerData.addTeamId(builder, teamId);
  return PatchPlayerData.endPatchPlayerData(builder);
}

unpack(): PatchPlayerDataT {
  return new PatchPlayerDataT(
    this.dname(),
    this.dnamePlaceholder(),
    this.money(),
    this.color1(),
    this.color2(),
    this.teamId()
  );
}


unpackTo(_o: PatchPlayerDataT): void {
  _o.dname = this.dname();
  _o.dnamePlaceholder = this.dnamePlaceholder();
  _o.money = this.money();
  _o.color1 = this.color1();
  _o.color2 = this.color2();
  _o.teamId = this.teamId();
}
}

export class PatchPlayerDataT implements flatbuffers.IGeneratedObject {
constructor(
  public dname: string|Uint8Array|null = null,
  public dnamePlaceholder: string|Uint8Array|null = null,
  public money: number = -1,
  public color1: bigint = BigInt('-1'),
  public color2: bigint = BigInt('-1'),
  public teamId: number = -1
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  const dname = (this.dname !== null ? builder.createString(this.dname!) : 0);
  const dnamePlaceholder = (this.dnamePlaceholder !== null ? builder.createString(this.dnamePlaceholder!) : 0);

  return PatchPlayerData.createPatchPlayerData(builder,
    dname,
    dnamePlaceholder,
    this.money,
    this.color1,
    this.color2,
    this.teamId
  );
}
}
